// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px","text":"forgetPassword_text__1A0p5"};